import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ModalWindowParameters} from '../modal-window/modal-window-parameters';

interface Widget {
  width: number;
  hiddenWidth: number;
  height: number;
  show: boolean;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class MapWidgetService {
  contentWrapperHeight: BehaviorSubject<{name: string, height: number}> = new BehaviorSubject<{name: string; height: number}>(null);
  widgetHeight: BehaviorSubject<{name: string, height: number}> = new BehaviorSubject<{name: string, height: number}>(null);

  getWidgetArray(): Widget[] {
    return JSON.parse(localStorage.getItem('widgetArrayVer20230513'));
  }

  getWidgetByName(name: string): Widget {
    return  this.getWidgetArray() ? this.getWidgetArray().find(widgetName => widgetName['name'] === name) : null;
  }

  saveWidget(wid: Widget) {
    let widgetArray = this.getWidgetArray();
    if (widgetArray === null) {
      widgetArray = [];
    }
    const index = widgetArray.findIndex(widgetName => widgetName['name'] === wid.name);

    if (index !== -1) {
      widgetArray[index] = {...wid};
    } else {
      widgetArray.push(wid);
    }

    this.setWidgetArray(widgetArray);
  }

  setWidgetArray(widgetArray) {
    localStorage.setItem('widgetArrayVer20230513', JSON.stringify(widgetArray));
  }

  constructor() {
  }
}
